import { z } from 'zod';
import { PaginationState, SortingState } from '@tanstack/react-table';

export const CheckSchema = z.object({
	id: z.number(),
	checkAmount: z.number(),
	checkNumber: z.number(),
	checkSequence: z.number(),
	checkType: z.string(),
	customerNumber: z.string().nullable(),
	fileIngestionId: z.number(),
	invoiceDate: z.date(),
	policyNumber: z.string().nullable(),
	reason: z.string().nullable(),
	insuredName1: z.string().nullable(),
	insuredName2: z.string().nullable(),
	street: z.string().nullable(),
	city: z.string().nullable(),
	state: z.string().nullable(),
	zip: z.string().nullable(),
	isUploaded: z.boolean().nullable(),
	error: z.string().nullable(),
});

export type CheckTransaction = z.infer<typeof CheckSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	params: object,
): Promise<{ data: CheckTransaction[]; total: number }> => {
	try {
		let queryString = '';
		if (params) {
			const paramsAsString = JSON.stringify(params)
				.replace(/:/g, '=')
				.replace(/,/g, '&')
				.replace(/[{}"]/g, '');

			const searchParams = new URLSearchParams(paramsAsString);
			if (pagination) {
				searchParams.append('pageSize', pagination.pageSize.toString());
				searchParams.append('pageIndex', pagination.pageIndex.toString());
			}

			if (sorting.length > 0) {
				searchParams.append('sortBy', sorting[0].id);
				searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
			}
			
			queryString = `?${searchParams.toString()}`;
		}
	const response = await fetch(`/GeoveraChecks${queryString}`);
		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};

export const downloadChecks = async (
	fileIngestionId: number,
): Promise<Blob> => {
	const response = await fetch(`/GeoveraChecks/download/${fileIngestionId}`, {
		method: 'GET',
	});

	return await response.blob();
};
